import React from 'react';
import { Helmet } from 'react-helmet';
import {
	getLocalizedPath,
	getUnlocalizedPath,
	withTrailingSlash,
} from '@src/utils/language-route';

const siteUrl = "https://lsftechnology.com";

const Head = props => {
	const path = withTrailingSlash(props.path || "/");
	const unlocalizedPath = getUnlocalizedPath(path);
	const canonicalUrl = `${siteUrl}${path}`;
	const isNewsDetail = /^\/news\/[^/]+\/?$/.test(unlocalizedPath);
	const englishUrl = `${siteUrl}${withTrailingSlash(getLocalizedPath(path, "en"))}`;
	const japaneseUrl = `${siteUrl}${withTrailingSlash(getLocalizedPath(path, "ja"))}`;

	return (
		<Helmet htmlAttributes={{ lang: props.lang }}>
			<title>{ props.title }</title>
			<link rel="canonical" href={canonicalUrl} />
			{ !isNewsDetail && <link rel="alternate" hrefLang="en" href={englishUrl} /> }
			{ !isNewsDetail && <link rel="alternate" hrefLang="ja" href={japaneseUrl} /> }
			{ !isNewsDetail && <link rel="alternate" hrefLang="x-default" href={englishUrl} /> }
			{ props.lang == "ja" ? (
			<link href="https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@400;500;700&display=swap" rel="stylesheet" />
			) : (
			<link href="https://fonts.googleapis.com/css2?family=Noto+Sans:wght@400;700&display=swap" rel="stylesheet" />
			)}
		</Helmet>
	)
}

Head.defaultProps = {
	title: "website of LSF Technology",
	path: "/",
	lang: "en",
}

export default Head;
